import { h, Component } from 'preact'
import Chevron from '../Chevron'
import { colors } from '../../constants'
import { Block } from '.'
import { Checkbox } from '../visual'

class MailBlock extends Component {
  constructor() {
    super()
    this.state = {
      agree: false,
      email: '',
      submitted: false,
      submitting: false,
    }
  }
  render() {
    return (
      <div
        style={{
          backgroundColor: colors.yellow,
          paddingBottom: 40,
        }}
      >
        <Chevron />
        <Block style={{ textAlign: 'center', marginBottom: -80 }}>
          <div style={{ fontSize: 30, marginBottom: 25 }}>
            Přečtěte si jako první, co skutečně dělají vaši politici!
          </div>
          <form
            role="form"
            className="std form-newsletter"
            id="newsletter"
            method="post"
            encType="application/x-www-form-urlencoded"
            action="https://rekonstrukcestatu.us4.list-manage.com/subscribe/post?u=5d66fd73a6a5bb1624ddc06a0&id=d28014602a"
            onSubmit={evt => {
              if (!this.state.agree || !this.state.email) {
                /* validation error */
                evt.preventDefault()
                this.setState({ submitted: true, submitting: false })
              } else {
                this.setState({ submitted: true, submitting: true })

                if (this.props.gaId && typeof dataLayer !== 'undefined') {
                  evt.preventDefault()
                  evt.persist()

                  window.dataLayer.push({
                    event: 'action.subscribe.newsletter',
                    action: {
                      subscribe: {
                        form: this.props.gaId,
                      },
                    },
                    eventCallback() {
                      evt.target.submit()
                    },
                  })
                }
              }
            }}
            noValidate
          >
            <div style={{ display: 'inline-block', marginRight: 15 }}>
              <input
                style={{
                  height: 40,
                  borderColor:
                    this.state.submitted && !this.state.email ? colors.red : '',
                }}
                type="text"
                name="EMAIL"
                id="EMAIL"
                className="text"
                placeholder="Váš e-mail"
                value={this.state.email}
                onChange={evt => this.setState({ email: evt.target.value })}
              />
            </div>
            <div style={{ display: 'inline-block', marginBottom: 15 }}>
              <button
                style={{ width: 230 }}
                type="submit"
                id="send"
                name="send"
                className="btn"
                value="send"
              >
                Mám zájem!
              </button>
            </div>
            <Checkbox
              id="mailblock-accept"
              checked={this.state.agree}
              onChange={agree => this.setState({ agree })}
            >
              Souhlasím se zpracováním osobních údajů{' '}
              <a href="/cs/zapoj-se/zasady-ochrany-udaju">
                dle těchto podmínek
              </a>.
              <div
                style={{
                  opacity: this.state.submitted && !this.state.agree ? 1 : 0,
                  pointerEvents:
                    this.state.submitted && !this.state.agree ? 'all' : 'none',
                  position: 'absolute',
                  color: colors.red,
                }}
              >
                Prosím, zaškrtněte souhlas s podmínkami.
              </div>
            </Checkbox>
          </form>
        </Block>
      </div>
    )
  }
}
export default MailBlock



// WEBPACK FOOTER //
// ./components/layout/MailBlock.js